import { render, staticRenderFns } from "./SuperAdminToolbar.vue?vue&type=template&id=4b11ea7a"
import script from "./SuperAdminToolbar.vue?vue&type=script&lang=js"
export * from "./SuperAdminToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports